/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Monatlichesarbeitsentgeltgroesserals520euro4Inputs */



/**

* @param {_Field_Monatlichesarbeitsentgeltgroesserals520euro4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_monatlichesarbeitsentgeltgroesserals520euro4 = /** @type {((inputs?: _Field_Monatlichesarbeitsentgeltgroesserals520euro4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Monatlichesarbeitsentgeltgroesserals520euro4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Mehr als 520 € im Monat")
});
export { _field_monatlichesarbeitsentgeltgroesserals520euro4 as "_field_monatlichesArbeitsentgeltGroesserAls520Euro" }